import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const LoomCalculator = Loader(lazy(() => import("src/content/loom")));

const loomRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Loom Calculator </title>
        </Helmet>
        <LoomCalculator />
      </>
    ),
  },
];

export default loomRoutes;
